import { LazyWrapper } from "@/components/wrapper/lazy-wrapper";
import SwapPlanPage from "@/features/meal-plan/pages/swap-plan";
import { lazyImport } from "@/utils/lazy-import-with-preload";
import { protectedSettingsRoute } from "./protected-setting-routes";
import { publicRoutes } from "./public-routes";
import { RouteItem } from "./routes.type";
import { onboardingRoutes } from "./step-routes";

export const OverviewPage = lazyImport(() => import("@/features/overview/pages/home"));
export const PlanMainScreen = lazyImport(() => import("@/pages/plans/main-screen"));
export const CalorieBudgetPage = lazyImport(() => import("@/pages/plans/calorie-budget"));
export const MyPlanPage = lazyImport(() => import("@/features/meal-plan/pages/my-plan"));
export const SavedMealsPage = lazyImport(() => import("@/features/meal-plan/pages/saved-meals"));
export const RecipeProcessingPage = lazyImport(
  () => import("@/features/meal-plan/pages/recipe-processing"),
);
export const RecipeEditProcessingPage = lazyImport(
  () => import("@/features/meal-plan/pages/recipe-edit-processing"),
);
export const MealDetailPage = lazyImport(() => import("@/features/meal-plan/pages/meal-detail"));
export const SwapPlanSearchPage = lazyImport(
  () => import("@/features/meal-plan/pages/swap-plan-search"),
);
export const PlanMethodologyPage = lazyImport(() => import("@/pages/plans/methodology"));
export const MealPreferencesPage = lazyImport(
  () => import("@/features/meal-plan/pages/meal-preferences"),
);
export const ShopList = lazyImport(() => import("@/features/shop-list/pages/shop-list"));
export const SettingsAndToolsPage = lazyImport(
  () => import("@/features/settings-and-tools/pages/settings-and-tools"),
);
export const HelpScreenPage = lazyImport(() => import("@/features/ai-chat/pages/help-screen"));

export const privateRoute: readonly RouteItem[] = [
  ...onboardingRoutes,
  // ...profilingGoToProfileRoute,
  ...protectedSettingsRoute,
  {
    path: "/overview",
    children: (
      <LazyWrapper>
        <OverviewPage />
      </LazyWrapper>
    ),
    isProtected: true,
  },
  {
    path: "/plans",
    children: (
      <LazyWrapper>
        <PlanMainScreen />
      </LazyWrapper>
    ),
    isProtected: true,
  },
  {
    path: "/plans/calorie-budget",
    children: (
      <LazyWrapper>
        <CalorieBudgetPage />
      </LazyWrapper>
    ),
    isProtected: true,
  },
  {
    path: "/plans/my-plan",
    children: (
      <LazyWrapper>
        <MyPlanPage />
      </LazyWrapper>
    ),
    isProtected: true,
  },
  {
    path: "/plans/saved-meals",
    children: (
      <LazyWrapper>
        <SavedMealsPage />
      </LazyWrapper>
    ),
    isProtected: true,
  },
  {
    path: "/plans/recipe-processing",
    children: (
      <LazyWrapper>
        <RecipeProcessingPage />
      </LazyWrapper>
    ),
    isProtected: true,
  },
  {
    path: "/plans/recipe-edit-processing",
    children: (
      <LazyWrapper>
        <RecipeEditProcessingPage />
      </LazyWrapper>
    ),
    isProtected: true,
  },
  {
    path: "/plans/meal-detail",
    children: (
      <LazyWrapper>
        <MealDetailPage />
      </LazyWrapper>
    ),
    isProtected: true,
  },
  {
    path: "/plans/swap-plan",
    children: (
      <LazyWrapper>
        <SwapPlanPage />
      </LazyWrapper>
    ),
    isProtected: true,
  },
  {
    path: "/plans/methodology",
    children: (
      <LazyWrapper>
        <PlanMethodologyPage />
      </LazyWrapper>
    ),
    isProtected: true,
  },
  {
    path: "/plans/meal-preferences",
    children: (
      <LazyWrapper>
        <MealPreferencesPage />
      </LazyWrapper>
    ),
    isProtected: true,
  },
  {
    path: "/shop-list",
    children: (
      <LazyWrapper>
        <ShopList />
      </LazyWrapper>
    ),
    isProtected: true,
  },
  {
    path: "/settings-and-tools",
    children: (
      <LazyWrapper>
        <SettingsAndToolsPage />
      </LazyWrapper>
    ),
    isProtected: true,
  },
  {
    path: "/help",
    children: (
      <LazyWrapper>
        <HelpScreenPage />
      </LazyWrapper>
    ),
    isProtected: true,
  },
] as const;

export const allRoutes: readonly RouteItem[] = [...publicRoutes, ...privateRoute] as const;
